// extracted by mini-css-extract-plugin
module.exports = {"loginCard":"styles_loginCard__4lP1u","loginContent":"styles_loginContent__77BLT"};